module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.showHeader ? 'padBox' : '', 'meetbox']
  }, [(_vm.showHeader) ? _c('x-header', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "top": "0",
      "z-index": "30",
      "max-width": "420px"
    },
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("谷町君分享會")]) : _vm._e(), _vm._v(" "), (_vm.hasData === true) ? [_vm._l((_vm.meetingListData), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "meetBox"
    }, [_c('div', [(item.meetingType != 2) ? _c('div', {
      staticClass: "time"
    }, [_c('span', [_vm._v(_vm._s(item.meetingTime))]), _vm._v(" "), (item.meetingType) ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "float": "right"
      }
    }, [_vm._v(_vm._s(item.meetingCity ? item.meetingCity : "線下"))]) : _vm._e(), _vm._v(" "), (!item.meetingType) ? _c('span', {
      staticStyle: {
        "display": "inline-block",
        "float": "right"
      }
    }, [_vm._v("在線")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "coverBox",
      style: ({
        height: _vm.bacheight,
        backgroundImage: 'url(' + item.meetingCoverImage + ')',
        maxHeight: '200px'
      }),
      on: {
        "click": function($event) {
          return _vm.toMeetdetail(item.id, item.weekend)
        }
      }
    }), _vm._v(" "), _c('div', [(item.meetingType != 2) ? _c('div', {
      staticClass: "desBox"
    }, [_c('div', {
      staticClass: "tit",
      on: {
        "click": function($event) {
          return _vm.toMeetdetail(item.id, item.weekend)
        }
      }
    }, [_vm._v(_vm._s(item.meetingName))]), _vm._v(" "), _c('div', {
      staticClass: "flexCenter"
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#44c2b8"
      }
    }), _vm._l((item.meetingLabelVOList), function(tag, index) {
      return _c('p', {
        key: index,
        staticStyle: {
          "padding": "2px 4px",
          "font-size": "11px",
          "margin-right": "4px",
          "margin-top": "3px",
          "margin-bottom": "2px",
          "display": "inline-block",
          "border": "1px solid #44c2b8",
          "border-radius": "5px",
          "color": "#44c2b8"
        },
        attrs: {
          "mini": "",
          "plain": "",
          "type": "primary"
        }
      }, [_vm._v(_vm._s(tag))])
    }), _vm._v(" "), (item.meetingMode == 1 && (item.meetingMinSeat - item.registerTotal <= 0) && (item.meetingBookingSeat - item.registerTotal)) ? _c('p', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "font-size": "12px",
        "line-height": "22px",
        "color": "grey"
      }
    }, [_c('span', {
      staticClass: "round green"
    }), _c('span', [_vm._v("已啟動（火熱報名中）")])]) : _vm._e(), _vm._v(" "), (item.meetingMinSeat - item.registerTotal > 0) ? _c('p', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "font-size": "12px",
        "line-height": "30px",
        "color": "grey"
      }
    }, [_c('span', {
      staticClass: "round org"
    }), _c('span', [_vm._v("差" + _vm._s(item.meetingMinSeat - item.registerTotal) + "位開啟")])]) : _vm._e(), _vm._v(" "), (!item.meetingMode && (item.meetingMinSeat - item.registerTotal <= 0) && (item.meetingBookingSeat - item.registerTotal)) ? _c('p', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "font-size": "12px",
        "line-height": "30px",
        "color": "grey"
      }
    }, [_c('span', {
      staticClass: "round green"
    }), _c('span', [_vm._v("已啟動（剩餘" + _vm._s(item.meetingBookingSeat - item.registerTotal) + "位）")])]) : _vm._e(), _vm._v(" "), (!item.meetingMode && (item.meetingMinSeat - item.registerTotal <= 0) && !(item.meetingBookingSeat - item.registerTotal)) ? _c('p', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "font-size": "12px",
        "line-height": "30px",
        "color": "grey"
      }
    }, [_c('span', {
      staticClass: "round red"
    }), _c('span', [_vm._v("已滿員")])]) : _vm._e()], 2), _vm._v(" "), (!(!item.meetingMode && !(item.meetingBookingSeat - item.registerTotal))) ? _c('div', [(item.weekend) ? _c('x-button', {
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "mini": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toMeetdetail(item.id, item.weekend)
        }
      }
    }, [_vm._v("立即報名")]) : _vm._e(), _vm._v(" "), (!item.weekend) ? _c('x-button', {
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "mini": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toMeetdetail(item.id, item.weekend)
        }
      }
    }, [_vm._v("立即報名")]) : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (item.meetingType == 2) ? _c('div', {
      staticClass: "desBox"
    }, [_c('div', {
      staticClass: "flexCenter"
    }, [_c('div', {
      staticStyle: {
        "flex": "1",
        "max-width": "24rem"
      }
    }, [_c('div', {
      staticClass: "tit",
      on: {
        "click": function($event) {
          return _vm.toMeetdetail(item.id, item.weekend)
        }
      }
    }, [_vm._v(_vm._s(item.meetingName))]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('p', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(item.meetingDesc))])])]), _vm._v(" "), (item.meetingType != 2 && !(!item.meetingMode && !(item.meetingBookingSeat - item.registerTotal))) ? _c('div', [(item.weekend) ? _c('x-button', {
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "mini": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toMeetdetail(item.id, item.weekend)
        }
      }
    }, [_vm._v("立即報名")]) : _vm._e(), _vm._v(" "), (!item.weekend) ? _c('x-button', {
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "mini": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toMeetdetail(item.id, item.weekend)
        }
      }
    }, [_vm._v("立即報名")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.meetingType == 2) ? _c('div', [_c('x-button', {
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "mini": "",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toMeetdetail(item.id, item.weekend)
        }
      }
    }, [_vm._v("聯繫我們")])], 1) : _vm._e()])]) : _vm._e()])])])
  }), _vm._v(" "), (!_vm.meetingId) ? [_vm._m(0)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.hasData === false) ? [_c('Empty')] : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "use-slot": "",
      "title": "手機號驗證",
      "show-cancel-button": "",
      "id": "verdialog",
      "confirm-button-text": "驗證"
    },
    model: {
      value: (_vm.showphone),
      callback: function($$v) {
        _vm.showphone = $$v
      },
      expression: "showphone"
    }
  }, [_c('div', {
    staticClass: "inputCont"
  }, [_c('div', {
    staticClass: "textsty"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biz),
      expression: "biz"
    }],
    staticStyle: {
      "background": "none",
      "font-size": "1.5rem",
      "color": "#2d2d2d",
      "border": "none"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.biz = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teleArr), function(option) {
    return _c('option', {
      domProps: {
        "value": option.intl_tele_code
      }
    }, [_vm._v(_vm._s(option.short_name))])
  }), 0)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "textInput",
    attrs: {
      "type": "tel",
      "name": "phoneNum",
      "placeholder": "請輸入手機號"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline_item"
  }, [_c('p', {
    staticClass: "meetingMore meetingReading"
  }, [_vm._v("更多會議正在籌備中哦~")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e70f8d","hasScoped":false}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Timeline.vue
// module id = 319
// module chunks = 1